<template>
  <div>
    <Tag color="error" @click="openForm = true;">计算公式</Tag><a>{{ items[now].name }}</a>
    <Modal v-model="openForm" footer-hide title="选择公式">
      <ul class="formula">
        <li @click="clickLi(index)" v-for="(item, index) in items" :key=index>
          <h3>{{ item.name }}</h3>
          <p>{{ item.des }}</p>
        </li>
      </ul>
    </Modal>
  </div>
</template>

<script>
export default {
  props: ["bbb",'option'],
  model: {
    prop: "bbb",
    event: "aaa",
  },
  data() {
    return {
      items: {
        0: {
          name: '单机×数量',
          des: '每件/板/重量/体积单价×对应数量'
        },
        1: {
          name: '单2222222222',
          des: '每件/板/重量/体积单价×对应数量'
        }
      },

      openForm: false,
      now: 0,
      nowText:''
    };
  },
  methods: {
    tt() {
      //console.log('获取到的值',this.bbb);
      this.bbb
    },
    clickLi(index){
      this.now=index;
      this.openForm=false;
    }
  },
  mounted() {
    this.tt();
  },
  watch: {
    now(v) {
      //this.$emit('aaa', v)
    },
    bbb(v) {
      this.tt();
    }
  },

};
</script>
<style>
.formula li {
  cursor: pointer;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/kehu/baojia/formula.vue